export const SUPPLIER_ROUTE_NAMES = {
  DASHBOARD: 'supplier-dashboard',
  PROFILE: 'supplier-profile',
  ORDERS: 'supplier-orders',
  PAYOUTS: 'supplier-payouts',
  PRODUCTS: 'supplier-products',
  PRODUCT_ADD: 'supplier-product-add',
  PRODUCT_EDIT: 'supplier-product-edit',
  REVIEW_PRODUCTS: 'supplier-review-products',
  NOT_FOUND: 'supplier-not-found',
}

export const SUPPLIER_PATHS = {
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  ORDERS: '/orders',
  PAYOUTS: '/payouts',
  PRODUCTS: '/product',
  PRODUCT_ADD: '/product/add',
  REVIEW_PRODUCTS: '/review-products',
  productEdit: (id) => `/product/edit/${id}`,
}

export const SUPPLIER_NAV_KEYS = {
  DASHBOARD: 'dashboard',
  PRODUCTS: 'products',
  ORDERS: 'orders',
  PAYOUTS: 'payouts',
}

export const SUPPLIER_LAYOUTS = {
  HEADER: 'header',
  BLANK: 'blank',
}
